module.exports = __webpack_public_path__ + "img/trust-seals.7c653a92.png";